export const sanitizeUserForStorage = user => {
  if (!user) return user;

  const persistedUser = { ...user };
  delete persistedUser.refreshToken;
  if (process.env.NODE_ENV !== 'development' && !persistedUser.isExportSession) {
    delete persistedUser.authToken;
  }
  return persistedUser;
};

export const reconcileUserWithCookie = (storedUser, cookieUser) => {
  if (!cookieUser) return storedUser;
  if (!storedUser || String(storedUser.userId) !== String(cookieUser.userId)) {
    return cookieUser;
  }

  const reconciledUser = { ...storedUser, ...cookieUser };
  // The API rotates the access token without rewriting the readable user
  // cookie. For the same identity, local storage therefore has the newer
  // token; the cookie remains the source of truth only for an account change.
  if (storedUser.authToken) reconciledUser.authToken = storedUser.authToken;
  return reconciledUser;
};

export const getStoredUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const sanitizedUser = sanitizeUserForStorage(user);
    if (sanitizedUser) {
      localStorage.setItem('user', JSON.stringify(sanitizedUser));
    }
    return sanitizedUser;
  } catch (error) {
    localStorage.removeItem('user');
    return null;
  }
};

export const storeUser = user => {
  const sanitizedUser = sanitizeUserForStorage(user);
  if (sanitizedUser) {
    localStorage.setItem('user', JSON.stringify(sanitizedUser));
  } else {
    localStorage.removeItem('user');
  }
};
